import { BlqRule } from '@bioavail/shared-types';

/**
 * Apply a BLQ rule to a point, returning the effective concentration (PSD §4.2.6).
 * M1 → 0; M2 → lloq/2; non-BLQ passes through unchanged.
 * Returns the effective concentration, plus a flag indicating whether M2 was
 * requested but LLOQ was missing (caller should warn and fall back to M1).
 */
export function applyBlqRule(
  point: { isBlq: boolean; concentration: number },
  rule: BlqRule,
  lloq?: number,
): { effectiveConcentration: number; missingLloq: boolean } {
  if (!point.isBlq) {
    return { effectiveConcentration: point.concentration, missingLloq: false };
  }

  switch (rule) {
    case BlqRule.M1:
      return { effectiveConcentration: 0, missingLloq: false };
    case BlqRule.M2: {
      if (lloq === undefined || lloq <= 0) {
        // Missing LLOQ — fall back to M1 with a flag.
        return { effectiveConcentration: 0, missingLloq: true };
      }
      return { effectiveConcentration: lloq / 2, missingLloq: false };
    }
    default:
      return { effectiveConcentration: 0, missingLloq: false };
  }
}
